// eslint-disable-next-line no-shadow
export enum PreferencesMutationTypes {
  SET_LANG = 'SET_LANG',
}
